import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { StoreProvider } from "./context/StoreContext";
import { AdminAuthProvider } from "./context/AdminAuth";

import AnnouncementBar from "./components/AnnouncementBar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import SearchOverlay from "./components/SearchOverlay";
import CookieConsent from "./components/CookieConsent";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import CategoryPage from "./pages/CategoryPage";
import CollectionsIndex from "./pages/CollectionsIndex";
import CollectionPage from "./pages/CollectionPage";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import OrderTracking from "./pages/OrderTracking";
import StaticPage from "./pages/StaticPage";
import NotFound from "./pages/NotFound";
import AdminApp from "./admin/AdminApp";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Storefront({ children }) {
  return (
    <div className="min-h-screen bg-[#070708] text-zinc-100 flex flex-col">
      <AnnouncementBar />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CartDrawer />
      <SearchOverlay />
      <CookieConsent />
    </div>
  );
}

const S = (el) => <Storefront>{el}</Storefront>;

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <StoreProvider>
          <ScrollTop />
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={S(<Home />)} />
            <Route path="/shop" element={S(<Shop />)} />
            <Route path="/category/:slug" element={S(<CategoryPage />)} />
            <Route path="/collections" element={S(<CollectionsIndex />)} />
            <Route path="/collection/:slug" element={S(<CollectionPage />)} />
            <Route path="/product/:slug" element={S(<ProductPage />)} />
            <Route path="/checkout" element={S(<Checkout />)} />
            <Route path="/order/:orderNumber" element={S(<OrderSuccess />)} />
            <Route path="/track" element={S(<OrderTracking />)} />
            <Route path="/page/:slug" element={S(<StaticPage />)} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="*" element={S(<NotFound />)} />
          </Routes>
        </StoreProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
